import {
    EUFY_HOME_APPLICATION_NAME,
    EUFY_LIFT_APPLICATION_NAME,
    EUFY_MEGA_APPLICATION_NAME,
    EUFY_SECURITY_APPLICATION_NAME,
    EUFY_SHOPIFY_APPLICATION_NAME,
  } from './constants'
  import { getCookie } from './cookie'
  import { getRegion, isPR } from './env'
  
  // 定义键类型
  type AppKeys = {
    [key: string]: string
  }
  
  // PR和QA键常量
  const PR_KEYS: AppKeys = {
    [EUFY_SECURITY_APPLICATION_NAME]: 'bd0a191c0ce8683092e4212f27740e79',
    [EUFY_MEGA_APPLICATION_NAME]: '2500a7d5617812f9d52515b2c8f20a3d',
    [EUFY_LIFT_APPLICATION_NAME]: '444b380e56f3ffad8aeb4c76494c15f9',
    [EUFY_HOME_APPLICATION_NAME]: '23b48113f8529e950ff725408cead3ab',
    [EUFY_SHOPIFY_APPLICATION_NAME]: '9ee1c6050e9f455a68ea06483f88be77',
  }
  
  const QA_KEYS: AppKeys = {
    [EUFY_SECURITY_APPLICATION_NAME]: '118c02b71e211049304bd70a0c971d44',
    [EUFY_MEGA_APPLICATION_NAME]: '208c02b71e211049304bd70a0c971d44',
    [EUFY_LIFT_APPLICATION_NAME]: '118c02b71e211049304bd70a0c971d47',
    [EUFY_HOME_APPLICATION_NAME]: '118c02b71e211049304bd70a0c971d48',
    [EUFY_SHOPIFY_APPLICATION_NAME]: '309c02b71e210038304bd70a1c971d77',
  }

  // 默认采用的预设key
  const DEFAULT_PR_KEY: string = 'bd0a191c0ce8683092e4212f27740e79'
  const DEFAULT_QA_KEY: string = '118c02b71e211049304bd70a0c971d44'
  
  // 定义URL类型
  type Urls = {
    [key: string]: {
      eu: string
      pr: string
      qa: string
    }
  }
  
  // 生成客户端密钥对 也称预设密钥
  export const getPresetKey = (currenAppName?:string): string => {
    const appName: string | null = getCookie('app_name') || currenAppName || EUFY_SECURITY_APPLICATION_NAME
    const keys: AppKeys = isPR() ? PR_KEYS : QA_KEYS
  
    return keys[appName || ''] || (isPR() ? DEFAULT_PR_KEY : DEFAULT_QA_KEY)
  }
  
  // URL常量
  const URLS: Urls = {
    'eufy_security_v3': {
      eu: 'https://security-app-eu.eufylife.com/v3/openapi/oauth/key/exchange',
      pr: 'https://security-app.eufylife.com/v3/openapi/oauth/key/exchange',
      qa: 'https://security-app-qa.eufylife.com/v3/openapi/oauth/key/exchange',
    },
    default: {
      eu: 'https://app-openapi-eu-pr.eufy.com/openapi/oauth/key/exchange',
      pr: 'https://app-openapi-us-pr.eufy.com/openapi/oauth/key/exchange',
      qa: 'https://vsaas-api-qa.eufylife.com/openapi/oauth/key/exchange', //没做统一，本地调试v3接口需要使用上面eufy_security_v3的接口地址
    },
  }
  
  // 密钥协商接口
  export const getOpenApiExchangeUrl = async (currenAppName?:string): Promise<string> => {
    const region: string = await getRegion()
    const appName: string | null = getCookie('app_name') || currenAppName || EUFY_SECURITY_APPLICATION_NAME
    const isEu: boolean = region === 'eu'
    const appUrls: { eu: string; pr: string; qa: string } = URLS[appName || ''] || URLS.default
  
    if (isEu) {
      return appUrls.eu
    }
    return isPR() ? appUrls.pr : appUrls.qa
  }
  
